import { Directive, ElementRef, EventEmitter, Input, OnDestroy, Optional, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { InputStateService } from 'services/input-state.service';
declare var $R: any;

@Directive({ selector: 'textarea[htmlEditor], input[htmlEditor]' })
export class HtmlEditorDirective implements OnDestroy {

	private editorActive = false;
	private hasInitialValue = false;
	private activationSubscription?: Subscription;
	private modelSubscription?: Subscription;

	@Output() blur = new EventEmitter();
	@Output() focus = new EventEmitter();

	@Input('htmlEditor')
	set htmlEditor(activate: boolean) {
		this.editorActive = activate;

		if (activate) {
			const focused = this.inputElement.nativeElement.matches(':focus') || this.inputElement.nativeElement.classList.contains('editable-field');
			setTimeout(() => {
				this.hasInitialValue = false;
				this.redactor({
					lang: 'da',
					minHeight: '85px',
					source: false,
					focusEnd: focused,
					breakline: true,
					toolbarFixed: false,
					styles: false,
					buttons: ['bold', 'italic', 'underline', 'lists', 'link'],
					callbacks: {
						changed: (content: string) => {
							if (this.ngModel &&
								(this.ngModel.model == null || this.ngModel.model.replace(/(\r\n)|\r|\n/gm, '') != content.replace(/(\r\n)|\r|\n/gm, ''))) {
								this.ngModel.control.markAsDirty();
								this.ngModel.viewToModelUpdate(content);
							}
						},
						focus: () => {
							this.focus.emit();
							if (this.inputStateService) this.inputStateService.focus();
						},
						blur: () => {
							this.blur.emit();
						}
					}
				});

				if (this.modelSubscription) this.modelSubscription.unsubscribe();
				if (this.ngModel) this.modelSubscription = this.ngModel.valueChanges?.subscribe(value => {
					if (!this.hasInitialValue || (value && this.editorActive)) {
						this.redactor('source.setCode', value ?? '');
						this.hasInitialValue = true;
					}
				});

			});
		} else {
			setTimeout(() => { this.redactor('destroy'); });
		}
	}

	constructor(private inputElement: ElementRef<HTMLElement>, @Optional() private ngModel: NgModel, @Optional() private inputStateService: InputStateService) {
		if (this.inputStateService) {
			this.activationSubscription = inputStateService.onActivated(() => {
				if (this.editorActive) {
					this.redactor('editor.focus');
					this.redactor('editor.endFocus');
				}
			});
		}
	}

	private redactor(arg1: any, arg2?: any) {
		return $R(this.inputElement.nativeElement, arg1, arg2);
	}

	ngOnDestroy(): void {
		if (this.activationSubscription) this.activationSubscription.unsubscribe();
		if (this.modelSubscription) this.modelSubscription.unsubscribe();
	}
}
